/* @flow */
import React, { useContext } from "react";
import type Schema from "nexia_mobile/models/schema";
import Dispatch from "nexia_mobile/flux_like/dispatch";
import Page from "nexia_mobile/components/Page";
import ScrollableArea from "nexia_mobile/components/Scrollable/ScrollableArea";
import SchemaFieldsFormManager, {
  type SubmitHandlerArgument,
} from "nexia_mobile/components/SchemaFieldsFormManager";
import AppBarWrapper from "nexia_mobile/components/TopBar/AppBarWrapper";
import AppBarButtons from "nexia_mobile/components/TopBar/AppBarButtons";
import CommonAppBarContainer from "nexia_mobile/components/TopBar/CommonAppBarContainer";
import BackboneListener from "nexia_mobile/components/BackboneListener";
import UserLanguageContext from "nx-components/ContextWrappers/UserLanguageContext";

type Props = {
  model: Schema,
  onCommit: () => Promise<void>,
};

const BuildingEditPage = (props: Props) => {
  const languageContext = useContext(UserLanguageContext);
  const language =
    languageContext.localeSet.nexia_mobile.pages.BuildingEditPage;
  const handleSave = ({
    setServerErrors,
    getFieldValues,
    validateBeforeSubmit,
  }: SubmitHandlerArgument) => {
    const { model, onCommit } = props;
    model.set(getFieldValues());
    const validationResult = validateBeforeSubmit();
    if (validationResult.hasErrors) {
      return;
    }

    Dispatch("RUN_PROMISE_WITH_SPINNER", () => {
      return model.commit().then((result) => {
        if (result && result.serverErrors) {
          setServerErrors(result.serverErrors);
          return Promise.resolve();
        } else {
          return onCommit();
        }
      });
    });
  };

  const { model } = props;
  const buildingComponents = model.getChildren();

  return (
    <BackboneListener
      listenTo={buildingComponents}
      debounceRender
      events={["add", "remove", "reset", "sort", "sync", "change"]}
    >
      {() => {
        return (
          <Page name="BuildingEditPage" fullyLoaded>
            <SchemaFieldsFormManager schema={model}>
              {({
                schemaFieldsForm,
                setServerErrors,
                getFieldValues,
                validateBeforeSubmit,
              }) => (
                <React.Fragment>
                  <AppBarWrapper>
                    <CommonAppBarContainer
                      title={model.get("title")}
                      iconRight={
                        <AppBarButtons
                          onCustomAction={() => {
                            handleSave({
                              setServerErrors,
                              getFieldValues,
                              validateBeforeSubmit,
                            });
                          }}
                          customActionTitle={language.save}
                        />
                      }
                    />
                  </AppBarWrapper>
                  <ScrollableArea>{schemaFieldsForm}</ScrollableArea>
                </React.Fragment>
              )}
            </SchemaFieldsFormManager>
          </Page>
        );
      }}
    </BackboneListener>
  );
};

export default BuildingEditPage;



// WEBPACK FOOTER //
// ./src/components/Pages/BuildingEditPage.jsx